import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, PageHeader, Space } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useBack } from '@/hooks/useBack'

const CreateLanguagePageHeader = () => {
  const { t } = useTranslation()
  const handleBack = useBack()
  return (
    <Space>
      <Button onClick={handleBack} icon={<ArrowLeftOutlined />}>
        {t('components.pages.admins.create.pageHeader.back')}
      </Button>
      <PageHeader ghost={false} title={t('components.pages.admins.create.pageHeader.title')} />
    </Space>
  )
}

CreateLanguagePageHeader.displayName = 'CreateLanguagePageHeader'
export default CreateLanguagePageHeader
